import {push} from 'connected-react-router';
import {AsyncResult, ServerError} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {getApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';
import userApi from 'Users/api/userApi';
import {
  changePasswordResetRequestQuestions,
  changePasswordUpdate,
  getPasswordResetRequestQuestions,
  PasswordRecoveryActionType,
  requestPasswordReset,
  updatePassword,
} from 'Users/ducks/passwordRecovery';
import {PasswordResetForm, PasswordUpdate} from 'Users/models/PasswordResetForm';
import {UserRouteConstants} from 'Users/Routes';

export function* requestPasswordResetApi(action: ReturnType<typeof requestPasswordReset>) {
  const result: E.Either<unknown, unknown> = yield call(userApi.requestPasswordReset, action.payload.username.value);

  if (E.isRight(result)) {
    yield put(push(UserRouteConstants.PASSWORD_RECOVERY_EMAIL_SENT));
  }
}

export function* resetPasswordSaga() {
  yield takeLatest(PasswordRecoveryActionType.REQUEST_PASSWORD_RESET, requestPasswordResetApi);
}

export function* getPasswordResetRequestQuestionsFromApi(action: ReturnType<typeof getPasswordResetRequestQuestions>) {
  yield getApiCallGenerator(
    () => userApi.getPasswordResetRequest(action.payload.requestKey),
    changePasswordResetRequestQuestions
  )({});
}

export function* getPasswordResetRequestQuestionsSaga() {
  yield takeLatest(
    PasswordRecoveryActionType.GET_PASSWORD_RESET_REQUEST_QUESTIONS,
    getPasswordResetRequestQuestionsFromApi
  );
}

export function* updatePasswordApi(action: ReturnType<typeof updatePassword>) {
  yield put(changePasswordUpdate(PasswordUpdate.Saving({})));
  const result: AsyncResult<unknown> = yield userApi.updatePassword(
    action.payload.id,
    action.payload.requestKey,
    action.payload.independentAgentProfile,
    action.payload.passwordResetForm
  );

  if (E.isRight(result)) {
    yield put(changePasswordUpdate(PasswordUpdate.Complete({})));
  } else {
    yield put(
      changePasswordUpdate(
        PasswordUpdate.Entry({
          form: PasswordResetForm.FailureToUpdate({
            ...action.payload.passwordResetForm,
            errorMessage: result.left instanceof ServerError ? result.left.errorDetails : undefined,
          }),
        })
      )
    );
  }
}

export function* updatePasswordSaga() {
  yield takeLatest(PasswordRecoveryActionType.UPDATE_PASSWORD, updatePasswordApi);
}

export default function*() {
  yield all([resetPasswordSaga(), getPasswordResetRequestQuestionsSaga(), updatePasswordSaga()]);
}
